var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAScholarships(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12036 14.48C7.12036 17.9225 8.48789 21.224 10.9221 23.6582C13.3563 26.0924 16.6578 27.46 20.1004 27.46C23.5429 27.46 26.8444 26.0924 29.2786 23.6582C31.7128 21.224 33.0803 17.9225 33.0803 14.48C33.0803 11.0375 31.7128 7.73597 29.2786 5.30175C26.8444 2.86753 23.5429 1.5 20.1004 1.5C16.6578 1.5 13.3563 2.86753 10.9221 5.30175C8.48789 7.73597 7.12036 11.0375 7.12036 14.48Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1003 28.7581L27.4556 41.5001L30.9127 34.506L38.6963 35.0079L31.341 22.2681M8.85533 22.2681L1.5 35.0101L9.28367 34.506L12.7407 41.4979L20.096 28.7581",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAScholarships);
export default __webpack_public_path__ + "static/media/AScholarships.23c5a58fdaae44596112ee474cdf8179.svg";
export { ForwardRef as ReactComponent };